import React from "react";
import {
  Button,
  CardContent,
  CssBaseline,
  Typography,
  Card,
  Box,
  Container,
  Grid,
} from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const CustomCard = ({ children }) => (
  <Card
    sx={{
      position: "relative",
      boxShadow: 3,
      overflow: "hidden",
      backgroundColor: "black",
      color: "white",
      transition: "all 0.5s ease",
      mt: { xs: 6, md: "none" },
    }}
  >
    {children}
  </Card>
);

function OfferImmigrate() {
  const cardData = [
    {
      icon: <ManageAccountsIcon sx={{ fontSize: 60 }} />,
      title: "Government Defence Contract Support",
      description: "Supporting defence suppliers with end-to-end contract management for Army Aviation projects",
      
    },
    {
      icon: <Brightness7Icon sx={{ fontSize: 60 }} />,
      title: "Equipment Sourcing & Management",
      description: "End-to-end equipment management, ensuring timely delivery, compliance, and optimal utilization",
      
    },
    {
      icon: <DomainAddIcon sx={{ fontSize: 60 }} />,
      title: "OEM Partnership & Certification",
      description: "Facilitating strong OEM partnerships and obtain official certifications for compliance and credibility",
      
    },
    {
      icon: <DoneOutlineIcon sx={{ fontSize: 60 }} />,
      title: "Government Agency Coordination",
      description: "Ensuring all regulatory requirements are met through effective government coordination",
      
    },
  ];

  return (
    <>
      <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.9)', color: 'white', mt: -2, py: 6, }} >
        {/* <Typography
          variant="h6"
          sx={{
            marginBottom: 2,
            mx: 10,
            textAlign: "center",
            mt: 2,
          }}
        >
          What We Offer
        </Typography> */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            // marginBottom: 4,
            textAlign: "center",
          }}
        >
          Defence Procurement Capabilities
        </Typography>

        <CssBaseline />

        <Container>
          <Box sx={{ padding: 3, pt: 3, }}>
            <Grid container spacing={3}>
              {cardData.map((card, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Box
                    sx={{
                      position: "relative",
                      // mt: 2, 
                      ".read-more": {

                      },
                      "&:hover": {
                        "& .icon-wrapper": {
                          backgroundColor: "white", // Background changes to white
                          color: "black", // Icon color changes to black
                          transform: "rotateY(3.142rad)",
                          // transform: "rotate(45deg)",
                          // transform: "translate(-50%, 10px)", // Moves icon down
                          // transition: "all 0.5s ease",
                        },
                        "& .card-content": {
                          background: "linear-gradient(to right, #0F758E, #0F758E)",
                          backgroundSize: "200% 100%",
                          backgroundPosition: "left",
                          transform: "background-color rotateY(3.142rad)",
                          transition: "background-position 1s ease",
                        },
                        "& .read-more": {
                          opacity: 1,
                          transform: "translateY(0)",
                        },
                      },
                    }}
                  >
                    {/* Icon Wrapper */}
                    <Box
                      className="icon-wrapper"
                      sx={{
                        position: "absolute",
                        top: "-42px",
                        left: "25%",
                        transform: "translate(-50%, 0)",
                        zIndex: 1,
                        borderRadius: "50%",
                        padding: "8px",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#0F758E", // Default background color
                        color: "white", // Default icon color
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "all 0.5s ease",
                      }}
                    >
                      {card.icon}
                    </Box>

                    {/* Card */}
                    <CustomCard>
                      <CardContent
                        className="card-content"
                        sx={{
                          paddingTop: 6,
                          textAlign: "left",
                          background: "black", // Default background color
                          color: "white",
                          py: 8,
                          pl: 6,

                          transition: "background-position 1s ease",
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{ fontWeight: "bold" }}
                        >
                          {card.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ marginBottom: 2, height: "40px", py: 2, }}
                        >
                          {card.description}
                        </Typography>
                        <Button
                          className="read-more"
                          sx={{
                            textDecoration: "none",
                            color: "white",
                            fontWeight: "bold",
                            opacity: 0,
                            transform: "translateY(10px)",
                            transition: "all 0.5s ease",
                            ml: -1,
                            mb: 1,

                          }}
                        >
                          {card.buttonText}{" "}
                          <ArrowForwardIosIcon
                            fontSize="small"
                            sx={{ height: "15px", pb: "2px" }}
                          />
                        </Button>
                      </CardContent>
                    </CustomCard>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  );
}



export default OfferImmigrate;